const MAKO_ASCII_LOGO = ` .+*+=----=+*+.   -**+=-----:: %*=========.    =*%*      %*%*:       .# :+%*:     -*+.
=%*         .*%- *%-           %+             += :##.    % .+%*:     .#   .=#*:.=*-
#%:          -%#:%#            %*=======:    *=...:##:   %   .+%#-   .#      +%%=
=%*          *%= #%:           %+          .*-::::::*%-  %      =##= .#    -*=.:**:
 :+#+------+#+:   =**=------:: %*----------*.        +%= %        -#%+# .+*-     .=+:
                                                                                    -+:`;

export default function AsciiLogo({ className = "" }) {
  return (
    <div className={`flex justify-center overflow-x-auto ${className}`}>
      <pre
        className="inline-block text-left font-mono text-[8px] leading-[1.1] text-zinc-50 sm:text-[9px]"
        aria-hidden="true"
      >
        {MAKO_ASCII_LOGO}
      </pre>
      <span className="sr-only">OceanX Mako</span>
    </div>
  );
}
